import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as reactLifecyclesCompat_es from '../node_modules/react-lifecycles-compat/react-lifecycles-compat.es.js';

var require$$3 = /*@__PURE__*/getAugmentedNamespace(reactLifecyclesCompat_es);

export { require$$3 as default };
